import base from '../../api/httpApi/base'
import { nanoid } from 'nanoid'
import { store } from '../../store/store'
import moment from "moment"


// export const socketMap = new Map();
const socketUtil = {
    websock: null,
    heartbeatId: null,
    heartbeatCheckId: null,
    reconection: false,
    heartArr: [],
    websockType: 1,
    websocketId: "",
    websockMessage: null,
    websockOpen: null,
    websockError: null,
    websockClose: null,
    initWebsocket: function (type = 1, message = null, open = null, error = null, close = null) {
        //return
        this.websockType = type;
        if (!this.websock) {
            this.websocketClearHeart();
            if (!sessionStorage.getItem("websocketId")) {
                sessionStorage.setItem("websocketId", nanoid());
            }
            //ws://
            this.websocketId = sessionStorage.getItem("websocketId");
            if (store.getters.getcustomer) {
                this.websocketId = store.getters.getcustomer.userId + '_' + this.websocketId;
            }
            const qz = window.location.protocol.indexOf("https") === -1 ? "ws://" : "wss://";
            this.websock = new WebSocket(`${qz}${base.websocketUrl}/sid?sid=${this.websocketId}`);
            // this.websock.setRequestHeader('Authorization', 'Bearer yourtoken');
            if (message) {
              // console.log(message);
                this.websock.onmessage = message;
                this.websockMessage = message;
            } else {
                this.websock.onmessage = this.websocketonmessage;
            }
            if (open) {
                this.websock.onopen = open;
                this.websockOpen = open;
            } else {
                this.websock.onopen = this.websocketonopen;
            }
            if (error) {
                this.websock.onerror = error;
                this.websockError = error;
            } else {
                this.websock.onerror = this.websocketonerror;
            }
            if (close) {
                this.websock.onclose = close;
                this.websockClose = close;
            } else {
                this.websock.onclose = this.websocketclose;
            }
        }
    },
    websocketReconnection: function () {
        if (this.websock) {
            this.websock.close();
            this.websock = null;
        }
        if (!this.reconection) {
            this.reconection = true;
            setTimeout(() => {
                //连接建立失败重连
                sessionStorage.setItem("websocketId", nanoid());
                this.initWebsocket(this.websockType, this.websockMessage, this.websockOpen, this.websockError, this.websockClose);
                this.reconection = false;
            }, 3000);
        }
    },
    websocketonopen: () => {
        console.log('websocket open', this.a.websock);
        this.a.websocketsend({
            MessageType: "userOnline"
        })
        this.a.websocketHeartbeat();
    },
    websocketonmessage: (e) => {
        // console.log('websocket Message', e);
        if (e.data) {
            const data = JSON.parse(e.data);
            if (data.MessageType === "0") {
                this.a.heartArr = [];
            }
        }
    },
    websocketonerror: () => {
        this.a.websocketClearHeart();
        console.log('websocket error');
        setTimeout(() => {
            // console.log('连接异常进行重连操作')
            this.a.websocketReconnection();
        }, 3 * 1000);
    },
    websocketclose: (e) => {
        console.log('websocket close', e);
        setTimeout(() => {
            // console.log('连接异常进行重连操作')
            this.a.websocketReconnection();
        }, 3 * 1000);
    },
    websocketsend: function (data) {
        //let isUser = "0";
        if (this.websock && this.websock.readyState === 1) {
            let isAdmin = false;
            let userId = -1;
            let displayName = "";
            if (store.getters.getcustomer) {
                //isUser = "1";
                isAdmin = this.websockType === 2;
                userId = store.getters.getcustomer.userId;
                displayName = store.getters.getcustomer.displayName
            }
            else if (store.getters.getAdminUser) {
                //isUser = "1";
                isAdmin = this.websockType === 2;
                userId = store.getters.getAdminUser.userId;
                displayName = store.getters.getAdminUser.displayName
            }
            data = Object.assign(data, {
                userId,
                isAdmin,
                displayName,
                SenderID: this.websocketId,
                ReceiverID: this.websocketId,
                time: moment().format('YYYY-MM-DD HH:mm:ss')
            })
            this.websock.send(JSON.stringify(data));
        }
    },
    websocketClearHeart: function () {
        console.log('websocket clear heart');
        if (this.heartbeatId) {
            clearInterval(this.heartbeatId);
            this.heartbeatId = null;
            this.heartArr = [];
        }
    },
    websocketHeartbeat: function () {
        if (!this.heartbeatId) {
            this.heartbeatId = setInterval(() => {
                let sendId = nanoid();
                this.heartArr.push(sendId);
                if (this.heartArr.length > 10) {
                    this.websocketReconnection()
                } else {
                    //console.log(123123, this.heartArr.length, this.heartbeatId);
                    this.websocketsend({
                        MessageType: "0",
                        Content: "心跳",
                    })
                }
            }, 30 * 1000);
        }
    }
}
export default socketUtil;


// WEBPACK FOOTER //
// ./src/assets/js/websocketTools.js